﻿namespace Solovis.Reports.Parameters {

  export class TagParameterControl extends Solovis.UI.BaseControl {

    private _portalServices: Solovis.Portal.IPortalServices;

    private parameterList;
    private settings;
    private tagSetId;
    private initialParameterValue;
    private currentTag;
    private _tagSetParam;

    private defaultTagSet;

    private parameterSet;

    private selectedTagLabel;
    private selectTagLink;

    private tagSetSelectorControl;
    private tagSelectorControlHost: Solovis.UI.ControlHost;

    private _selectionDialog: Solovis.UI.Dialog;


    constructor(options, info) {
      super(options, info);

      this._portalServices = options.portalServices;

      this.parameterList = options.parameterList;
      if (this.parameterList) {
        this.parameterSet = this.parameterList.parameterSet;
      }

      this.defaultTagSet = info && info.defaultTagSet ? info.tagSet : null;
      this.settings = options.settings ? options.settings : {};
      this.tagSetId = this.settings.tagSetId ? this.settings.tagSetId : (this.defaultTagSet ? this.defaultTagSet.tagSetId : null);

      this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : false;
      this.currentTag = this.initialParameterValue;

      // If _tagSetParam is set, it is the tag set to use for this tag set selector.
      this._tagSetParam = null;
      if (this.settings.dependsOn) {
        this._tagSetParam = this.settings.dependsOn.tagSet ? this.settings.dependsOn.tagSet : null;
      }

    }




    public static preload(newValue, callback, portalServices: Solovis.Portal.IPortalServices) {
      if (newValue && newValue.tagSetId) {
        portalServices.rpc().invoke(
          "~/Selectors/TagSelector/GetTagData", { tagId: newValue.tagId, tagSetId: newValue.tagSetId },
          function (response, success) {
            if (success) {
              var tagData = response.result;
              callback(tagData, true);
            }
            else {
              callback(null, false);
            }
          });
      }
      else {
        callback(null, true);
      }
    }

    public static serializeParameterValue(value): any {
      if (value) {
        if (value.tagId) {
          return {
            tagId: value.tagId,
            tagSetId: value.tagSetId ? value.tagSetId : null
          };
        }
        else if (value.tagSetId) {
          return {
            tagSetId: value.tagSetId ? value.tagSetId : null
          };
        }
      }

      return null;
    }

    public static getLabel(value): string | undefined {
      let label = "";
      if (value?.tagLabel) {
        label = value.tagLabel + " ";
      }
      label += "(" + value.tagSetLabel + ") ";

      return label;
    }


    public doInit() {
      var self = this;

      $(this.parameterSet).bind("parameterValueChanged", function () {
        self._checkForMatchingDependencies();
      });
    }

    public doRender() {
      var self = this;

      var linksWrapper = $("<div>")
        .css({ display: "flex", alignItems: "center", gap: "10px" })
        .appendTo(this.container);

      this.selectedTagLabel = $("<a>").appendTo(linksWrapper)
        .click(function (e) {
          if (self.currentTag && self.currentTag.tagId) {
            Solovis.UI.PopupLinkPanel.showLinks({
              offset: { left: e.pageX, top: e.pageY },
              links: self._portalServices.reportLinker().getTagLinks(self.currentTag)
            });
          }
        });

      this.selectTagLink = $("<a>")
        .html("<span class='fa fa-pencil'></span>")
        .css({ "padding-right": "2px" })
        .appendTo(linksWrapper);

      this.selectTagLink.click(function () {
        self._toggleSelectorDialog(function (tag) {
          self._setCurrentTagData(tag);
          self.notifyParameterValueChanged();
        });
      });

      if (this.tagSetId && Solovis.Portal.CachedPermissions.doesUserHavePermission("TagSetEdit")) {
        var addNewTagLink = $("<a>")
          .css({ "font-size": "12px" })
          .text("Add New Tag")
          .appendTo(linksWrapper);

        Solovis.UI.DomHelper.focusableClick(addNewTagLink, function () {
          new (Solovis as any).Reports.Parameters.AddTagDialog({
            tagSetId: self.tagSetId,
            portalServices: self._portalServices,
            saveCallback: function (tag) {
              self._setCurrentTagData(tag);
              self.notifyParameterValueChanged();
            }
          });
        });
      }

      if (this.currentTag) {
        this._setCurrentTagData(this.currentTag);
      }
    }

    public _setCurrentTagData(tagSetData) {
      this.currentTag = tagSetData;
      if (this.currentTag) {
        var label = "";
        if (this.currentTag.tagLabel) {
          label = this.currentTag.tagLabel + " ";
        }
        label += "(" + this.currentTag.tagSetLabel + ") ";
        this.selectedTagLabel.text(label + " ");
      }
      else {
        this.selectedTagLabel.text("");
      }
    }

    public setParameterValue(newValue, more?) {
      Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
        this, TagParameterControl, this._setCurrentTagData, newValue, more);
    }


    public getParameterValue() {
      if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
        return this.initialParameterValue ? this.initialParameterValue : null;
      }
      else if (this.currentTag) {
        return Solovis.deepCopy(this.currentTag);
      }
      else {
        return null;
      }
    }

    public notifyParameterValueChanged() {
      $(this).trigger("parameterValueChanged");
    }


    public _toggleSelectorDialog(selectionCallback) {
      var self = this;

      if (this._selectionDialog) {
        // We already have the selection dialog open, so close it.
        this._selectionDialog.close();
        this._selectionDialog = null;
        return;
      }

      if (this._tagSetParam) {
        this._checkForMatchingDependencies();

        // We are expecting the tag set to be determined by another parameter.
        if (!this.tagSetId) {
          Solovis.UI.alert("Tag set not selected.");
          return;
        }
      }

      var selectorControlHostDiv = $("<div>");
      var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });
      var selectorControl = new Solovis.InvDataSelectors.TagSelectorControl({
        parameterSet: this.parameterSet,
        controlHost: selectorControlHostDiv,
        portalServices: this._portalServices,
        tagSetId: this.tagSetId,
        initialValue: this.currentTag,
        allowNullTag: this.settings.allowNullTag,
        defaultTagSet: this.defaultTagSet,
        selectionCallback: function (tag) {
          selectionCallback(tag);
          self._selectionDialog.close();
        },
        cancelCallback: function () {
          self._selectionDialog.close();
        }
      });
      selectorControlHost.setCurrentControl(selectorControl);


      // Determine dialog position.        
      var linkOffset = $(this.selectedTagLabel).offset();
      var linkHeight = $(this.selectTagLink).outerHeight();
      var dialogPosition = {
        left: linkOffset.left,
        top: linkOffset.top + linkHeight + 5
      };

      var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

      var desiredWidth = Math.min($(window).width() * .8, 250);
      var desiredHeight = Math.min($(window).height() * .8, 300);

      var minWidth = 100;
      var minHeight = 100;

      this._selectionDialog = new Solovis.UI.Dialog({
        container: selectorControlHostDiv,
        ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

        title: false,
        autoOpen: true,
        destroyOnClose: true,
        actions: ["Close"],
        noAnimation: true,
        position: adjustedPosition,
        width: desiredWidth,
        height: desiredHeight,
        minHeight: minHeight,
        minWidth: minWidth,

        buttons: [
          {
            label: "Clear",
            click: function () {
              selectionCallback(self.defaultTagSet ? { tagSetId: self.defaultTagSet.tagSetId, tagSetLabel: self.defaultTagSet.label } : null);
              self._selectionDialog.close();
            }
          },
          {
            label: "Cancel",
            click: function () {
              self._selectionDialog.close();
            }
          }
        ],

        activate: function () {
          var overallHeight = this.getAvailableContentHeight();
          selectorControl.setAvailableHeight(overallHeight);
        },

        resize: function () {
          var overallHeight = this.getAvailableContentHeight();
          selectorControl.setAvailableHeight(overallHeight);
        },

        deactivate: function () {
          self._selectionDialog = null;
        },

        contentWidthSizer: {
          setWidth: (newWidth) => {
            selectorControl.setWidth(newWidth);
          }
        }
      });
    }


    public _checkForMatchingDependencies() {
      // If the user changes the dependent tag set, we should clear the value here.        

      if (this._tagSetParam) {
        var tagSet = this.parameterSet.getParameterValue(this._tagSetParam);

        if (this.currentTag) {
          var different = false;

          if (tagSet) {
            if (tagSet.tagSetId != this.currentTag.tagSetId) {
              different = true;
            }
          }
          else {
            different = true;
          }

          if (different) {
            this.setParameterValue(null);
          }
        }

        if (tagSet) {
          this.tagSetId = tagSet.tagSetId;
        }
      }
    }
  }

}